import { uniq } from 'lodash'
import { VueI18n } from 'vue-i18n'

declare const config
const LOCALES_MAPPING: LocalesMap = config.locales_mapping

/**
 * There is 2 differents locales keys :
 * appLocale, the one used in TranslatedString (ex: fr)
 * i18nLocale, the one used for Reporter translations (ex: fr-DIOR)
 */
interface LocalesMap {
    i18nToApp: {[i18nKey: string]: string},
    appToI18n: {[appToI18n: string]: string},
}

/**
 * 
 * @param appLocale The locale key used in TranslatedString
 * @returns The locale key used in Reporter translations (i18nLocale)
 */
export function getI18nLocaleFromAppLocale(appLocale: string): string | null {
    try {
        if(LOCALES_MAPPING.appToI18n[appLocale]) {
            return LOCALES_MAPPING.appToI18n[appLocale]
        }
    } catch(err) {}
    
    return null
}

/**
 * 
 * @param i18nLocale The locale key used in Reporter translations
 * @returns The locale key used in TranslatedString (appLocale)
 */
export function getAppLocaleFromI18nLocale(i18nLocale: string): string | null {
    try {
        if(LOCALES_MAPPING.i18nToApp[i18nLocale]) {
            return LOCALES_MAPPING.i18nToApp[i18nLocale]
        }
    } catch(err) {}
    
    return null
}

/**
 * Checks if the translation key exists for the current locale or a locale set to be the callback
 * of the current locale
 * @param i18n 
 * @param key 
 * @returns
 */
export function hasTranslationOrFallback(i18n: VueI18n, key): boolean {
    let res: boolean = i18n.te(key)

    const locale = i18n.locale
    const fallbackConf = i18n.fallbackLocale

    /*
    * We consider that fallbackConf looks like this:
    * {
        'fr-DIOR': ['fr', 'en'],
        'default': ['en'],
    * }
    * It could look differently, but since we set it this way in @skinsoft/i18n/src/i18n.ts
    * we don't need to handle other cases
    */
    let fallbackLocales: string[] = []
    if(fallbackConf[locale]) {
        fallbackLocales = uniq(fallbackConf[locale])
    } else {
        fallbackLocales = uniq(fallbackConf['default'])
    }
    
    if(!res && fallbackLocales.length) {
        for(const fallbackLocale of fallbackLocales) {
            res = i18n.te(key, fallbackLocale)
            if(res) {
                return res
            }
        }
    }

    return res
}